export default __webpack_public_path__ + "static/spacing-4cde757ce195d57c8406c2f92f1f8121.png";